export const appendChildrenToTree = <T extends { children?: T[] }>(
  list: T[],
  parentValue: unknown,
  children: T[],
  keyToVerify: keyof T
): T[] =>
  list.map((node) => {
    if (node[keyToVerify] === parentValue) {
      return {
        ...node,
        children,
      }
    }

    if (node.children) {
      return {
        ...node,
        children: appendChildrenToTree(
          node.children,
          parentValue,
          children,
          keyToVerify
        ),
      }
    }

    return node
  })
